if (!customElements.get('bts-product-details')) {
  class BtsProductDetails extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('[data-bts-details-source]');
      const enhanced = this.querySelector('[data-bts-details-enhanced]');
      if (!source || !enhanced) return;

      const parsed = this.parseContent(source);
      if (parsed.rows.length < 2) return;

      const summaryLimit = Number.parseInt(this.dataset.summaryLimit, 10) || 6;
      const summaryRows = this.getSummaryRows(parsed.rows, summaryLimit);
      const fragment = document.createDocumentFragment();

      if (parsed.intro) {
        const intro = document.createElement('p');
        intro.className = 'bts-product-details__intro';
        intro.textContent = parsed.intro;
        fragment.appendChild(intro);
      }

      if (summaryRows.length) fragment.appendChild(this.buildSummary(summaryRows));

      const groupsTitle = document.createElement('h3');
      groupsTitle.className = 'bts-product-details__groups-title';
      groupsTitle.textContent = 'Todas las especificaciones';
      fragment.appendChild(groupsTitle);

      const groups = document.createElement('div');
      groups.className = 'bts-product-details__groups';
      parsed.groups.filter((group) => group.rows.length).forEach((group) => {
        groups.appendChild(this.buildGroup(group));
      });
      fragment.appendChild(groups);

      if (this.dataset.showOriginal === 'true') {
        const original = document.createElement('details');
        original.className = 'bts-product-details__original';
        const summary = document.createElement('summary');
        summary.textContent = 'Ver descripción original completa';
        original.appendChild(summary);
        source.classList.add('bts-product-details__source--inside');
        original.appendChild(source);
        fragment.appendChild(original);
      } else {
        source.hidden = true;
      }

      enhanced.appendChild(fragment);
      enhanced.hidden = false;
    }

    parseContent(source) {
      const elements = [...source.querySelectorAll('h1,h2,h3,h4,h5,h6,p,li')];
      const lines = [];

      elements.forEach((element) => {
        if (element.querySelector('h1,h2,h3,h4,h5,h6,p,li')) return;
        const clone = element.cloneNode(true);
        clone.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
        clone.textContent.split(/\n+/).forEach((line) => {
          const clean = line.replace(/^[•\-*\s]+/, '').replace(/\s+/g, ' ').trim();
          if (clean) lines.push(clean);
        });
      });

      if (!lines.length) {
        source.textContent.split(/\n+/).forEach((line) => {
          const clean = line.replace(/^[•\-*\s]+/, '').replace(/\s+/g, ' ').trim();
          if (clean) lines.push(clean);
        });
      }

      let intro = '';
      let currentGroup = { title: 'Características principales', rows: [] };
      const groups = [];
      const rows = [];

      lines.forEach((line) => {
        const colonIndex = line.indexOf(':');
        if (colonIndex > 0 && colonIndex < 65) {
          const label = line.slice(0, colonIndex).trim();
          const value = line.slice(colonIndex + 1).trim();
          if (!label || !value) return;
          const row = { label, value, group: currentGroup.title, index: rows.length };
          currentGroup.rows.push(row);
          rows.push(row);
          return;
        }

        if (line.length > 90) {
          intro = intro ? `${intro} ${line}` : line;
          return;
        }

        if (!intro && groups.length === 0 && currentGroup.rows.length === 0) {
          intro = line;
          return;
        }

        if (currentGroup.rows.length) groups.push(currentGroup);
        currentGroup = { title: line, rows: [] };
      });

      if (currentGroup.rows.length) groups.push(currentGroup);
      return { intro, groups, rows };
    }

    getSummaryRows(rows, limit) {
      const priorities = [
        'modelo',
        'capacidad',
        'tipo',
        'tecnologia',
        'tecnología',
        'tamaño',
        'resolucion',
        'resolución',
        'frigorias',
        'frigorías',
        'potencia',
        'eficiencia',
        'color',
        'ancho',
      ];

      const normalize = (text) => text.toLocaleLowerCase('es');
      return [...rows]
        .map((row) => {
          const label = normalize(row.label);
          const priority = priorities.findIndex((term) => label.includes(term));
          return { ...row, priority: priority === -1 ? 999 : priority };
        })
        .sort((a, b) => a.priority - b.priority || a.index - b.index)
        .slice(0, limit);
    }

    buildSummary(rows) {
      const wrapper = document.createElement('div');
      wrapper.className = 'bts-product-details__summary';
      const title = document.createElement('h3');
      title.textContent = 'Resumen rápido';
      wrapper.appendChild(title);

      const grid = document.createElement('dl');
      rows.forEach((row) => {
        const item = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = row.label;
        description.textContent = row.value;
        item.append(term, description);
        grid.appendChild(item);
      });
      wrapper.appendChild(grid);
      return wrapper;
    }

    buildGroup(group) {
      const details = document.createElement('details');
      details.className = 'bts-product-details__group';
      const summary = document.createElement('summary');
      const title = document.createElement('span');
      const count = document.createElement('small');
      title.textContent = group.title;
      count.textContent = `${group.rows.length} datos`;
      summary.append(title, count);
      details.appendChild(summary);

      const list = document.createElement('dl');
      group.rows.forEach((row) => {
        const item = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = row.label;
        description.textContent = row.value;
        item.append(term, description);
        list.appendChild(item);
      });
      details.appendChild(list);
      return details;
    }
  }

  customElements.define('bts-product-details', BtsProductDetails);
}
